import {
  WORKBOOK_ITEM_NAME_MAX_LENGTH,
  type WorkbookDefinition,
} from '@erp/shared-types';

/**
 * `base`, or `base 2`, `base 3`… : the first name none of `taken` has,
 * ignoring case, as a spreadsheet names a new sheet or table. With
 * `maxLength`, the base is cut so the numbered name still fits.
 */
export function unusedName(
  taken: Iterable<string>,
  base: string,
  maxLength = WORKBOOK_ITEM_NAME_MAX_LENGTH,
): string {
  const names = new Set([...taken].map((name) => name.toLowerCase()));
  let name = base.slice(0, maxLength).trim();
  for (let count = 2; names.has(name.toLowerCase()); count += 1) {
    const suffix = ` ${count}`;
    name = `${base.slice(0, maxLength - suffix.length).trimEnd()}${suffix}`;
  }
  return name;
}

/** The names a Formula or Lookup can read a table by: every Source and Worksheet. */
export function tableNames(
  definition: Pick<WorkbookDefinition, 'sources' | 'sheets'>,
): string[] {
  return [
    ...definition.sources.map((item) => item.name),
    ...definition.sheets.map((item) => item.name),
  ];
}

/**
 * A new Worksheet's name: its input's name and `suffix` ("Orders sheet"),
 * numbered from 2 ("Orders sheet 2") when a table already has it.
 */
export function newWorksheetName(
  definition: Pick<WorkbookDefinition, 'sources' | 'sheets'>,
  inputName: string,
  suffix: string,
): string {
  return unusedName(tableNames(definition), `${inputName} ${suffix}`);
}
